module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon19.6ff5f182.png";